'use client'

import { ReactNode } from 'react'

interface LogoSectionProps {
  logo?: ReactNode
  logoHref?: string
  onLogoClick?: () => void
}

export function LogoSection({ logo, logoHref, onLogoClick }: LogoSectionProps) {
  if (!logo) return null

  return (
    <div className="flex-shrink-0">
      <div className="flex items-center">
        {logoHref ? (
          <a href={logoHref} className="flex items-center">
            {logo}
          </a>
        ) : (
          <button 
            onClick={onLogoClick}
            className="flex items-center focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 rounded"
          >
            {logo}
          </button>
        )}
      </div>
    </div>
  )
}
